import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/etsy-suspended-account';

export default function Example() {
  return (
    <>
      <Head>
        <title>Etsy Account Suspended: Here's How to Avoid It</title>
        <meta
          name='description'
          content="Have you received an email from Etsy that your account has been suspended? If so, don't panic! This article will cover what happens when your Etsy account is suspended and how to get it back up."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/etsy-suspended-account' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/etsy-suspended-account' />
        <meta property='og:title' content="Etsy Account Suspended: Here's How to Avoid It" />
        <meta
          property='og:description'
          content="Have you received an email from Etsy that your account has been suspended? If so, don't panic! This article will cover what happens when your Etsy account is suspended and how to get it back up."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-10-21T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-10-21T00:00:00-00:00' />
        <meta property='article:tag' content='Etsy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
